import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\clawdhost\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\clawdhost\\node_modules\\next\\dist\\client\\image-component.js");
